var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionLeft01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53151 6.4145C9.20806 6.67326 9.15562 7.14522 9.41438 7.46867L13.0396 12.0002L9.41438 16.5316C9.15562 16.8551 9.20806 17.327 9.53151 17.5858C9.85495 17.8446 10.3269 17.7921 10.5857 17.4687L14.5857 12.4687C14.8048 12.1948 14.8048 11.8055 14.5857 11.5316L10.5857 6.53163C10.3269 6.20818 9.85495 6.15574 9.53151 6.4145Z",
    fill: "#28303F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionLeft01);
export default __webpack_public_path__ + "static/media/direction-left 01.cfd7e3df438e61b1b3521d35513e6334.svg";
export { ForwardRef as ReactComponent };